import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-slate-200 bg-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-blue-600 text-white">
            <ShieldCheck className="h-3.5 w-3.5" strokeWidth={2.5} />
          </span>
          <span className="font-display font-semibold text-slate-900 text-sm">
            KnowYourPolicy<span className="text-blue-600">.ai</span>
          </span>
        </div>
        <p className="text-xs text-slate-500 max-w-lg leading-relaxed">
          We explain your policy in plain English. We never advise. Coverage
          decisions rest with your insurer — always verify against the original
          policy wording before making a claim.
        </p>
        <div className="flex items-center gap-4">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="text-xs text-slate-600 hover:text-slate-900 font-medium"
          >
            Terms &amp; Disclaimer
          </Link>
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} KnowYourPolicy.ai
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
